import { render, staticRenderFns } from "./WagonBasedata.vue?vue&type=template&id=4e6044a8&scoped=true"
import script from "./WagonBasedata.vue?vue&type=script&lang=js"
export * from "./WagonBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6044a8",
  null
  
)

export default component.exports